import { configureStore } from "@reduxjs/toolkit";
import rootReducer, { preloadedRootState } from "./reducers";


const store = configureStore({
    reducer: rootReducer,
    preloadedState: preloadedRootState,
    devTools: true
})

export default store;